const blop = require("!/Users/batistebieler/project/blop-language/src/runtime.js");
let Index;
let { MemePage } = require('./MemePage/MemePage.blop');
let { DogPage } = require('./DogPage/DogPage.blop');
let { PetStore } = require('./PetStore/index.blop');
let { TodoListPage } = require('./TodoListPage/TodoListPage.blop');
let { CounterPage } = require('./ComponentState/ComponentStatePage.blop');
let { FetchPage } = require('./FetchPage/FetchPage.blop');
let { saveState } = require('./services.blop');
let style = require('./style.css');

function navigationLinks(state) {
  function memePage(e) {
    state.$.router.go('/meme');
    e.preventDefault();
  };
  function dogPage(e) {
    state.$.router.go('/dogs');
    e.preventDefault();
  };
  function todoPage(e) {
    state.$.router.go('/todo');
    e.preventDefault();
  };
  function petStorePage(e) {
    state.$.router.go('/petstore');
    e.preventDefault();
  };
  function statePage(e) {
    state.$.router.go('/state');
    e.preventDefault();
  };
  function fetchPage(e) {
    state.$.router.go('/fetch');
    e.preventDefault();
  };
  return ({ memePage, dogPage, todoPage, petStorePage, statePage, fetchPage })
};

function linkList(state) {let links;
  links = navigationLinks(state);
  const __1c = []; const __1a = {};
    const __2c = []; const __2a = {};
      const __3c = []; const __3a = {}; __3a['href'] = '/dog'; __3a['on'] = ({ click: links.dogPage }); const __4 = 'Dog breed guessing game'; Array.isArray(__4) ? __3c.push(...__4) : __3c.push(__4); const __3 = blop.h('a', __3a, __3c); __2c.push(__3);
     const __2 = blop.h('p', __2a, __2c); __1c.push(__2);
    const __5c = []; const __5a = {};
      const __6c = []; const __6a = {}; __6a['href'] = '/petstore'; __6a['on'] = ({ click: links.petStorePage }); const __7 = 'A pet store'; Array.isArray(__7) ? __6c.push(...__7) : __6c.push(__7); const __6 = blop.h('a', __6a, __6c); __5c.push(__6);
     const __5 = blop.h('p', __5a, __5c); __1c.push(__5);
    const __8c = []; const __8a = {};
      const __9c = []; const __9a = {}; __9a['href'] = '/meme'; __9a['on'] = ({ click: links.memePage }); const __10 = 'Blank meme page'; Array.isArray(__10) ? __9c.push(...__10) : __9c.push(__10); const __9 = blop.h('a', __9a, __9c); __8c.push(__9);
     const __8 = blop.h('p', __8a, __8c); __1c.push(__8);
    const __11c = []; const __11a = {};
      const __12c = []; const __12a = {}; __12a['href'] = '/todo'; __12a['on'] = ({ click: links.todoPage }); const __13 = 'A basic todo app'; Array.isArray(__13) ? __12c.push(...__13) : __12c.push(__13); const __12 = blop.h('a', __12a, __12c); __11c.push(__12);
     const __11 = blop.h('p', __11a, __11c); __1c.push(__11);
    const __14c = []; const __14a = {};
      const __15c = []; const __15a = {}; __15a['href'] = '/state'; __15a['on'] = ({ click: links.statePage }); const __16 = 'Component state'; Array.isArray(__16) ? __15c.push(...__16) : __15c.push(__16); const __15 = blop.h('a', __15a, __15c); __14c.push(__15);
     const __14 = blop.h('p', __14a, __14c); __1c.push(__14);
    const __17c = []; const __17a = {};
      const __18c = []; const __18a = {}; __18a['href'] = '/fetch'; __18a['on'] = ({ click: links.fetchPage }); const __19 = 'Fetch state'; Array.isArray(__19) ? __18c.push(...__19) : __18c.push(__19); const __18 = blop.h('a', __18a, __18c); __17c.push(__18);
     const __17 = blop.h('p', __17a, __17c); __1c.push(__17);
   const __1 = blop.h('div', __1a, __1c); return __1;
};

function navigation(state) {let links, __26, __31, __32, __33, __34, __35, __36, __41, __45, __47, __49;
  links = navigationLinks(state);

  function saveStateEvent(e) {
    saveState(state);
    e.preventDefault();
  };

  function navItem(type, go, name) {let classes, __22;
    classes = 'nav-item';
    if (state.page === type) {
      classes = `${classes} active`;
    }
    const __20c = []; const __20a = {}; __20a['class'] = classes;
      const __21c = []; const __21a = {}; __21a['href'] = `/${type}`; __21a['class'] = 'nav-link'; __21a['on'] = ({ click: go });
        __22 = name; Array.isArray(__22) ? __21c.push(...__22) : __21c.push(__22); ;
       const __21 = blop.h('a', __21a, __21c); __20c.push(__21);
     const __20 = blop.h('li', __20a, __20c); return __20;
  };

  const __23c = []; const __23a = {}; __23a['class'] = 'navbar navbar-expand-lg navbar-light bg-light';
    const __24c = []; const __24a = {}; __24a['class'] = 'navbar-brand'; __24a['href'] = '/';
      const __25c = []; const __25a = {}; __25a['src'] = '/blop/favicon.ico'; __25a['width'] = '37'; __25a['height'] = '33'; __25a['class'] = 'd-inline-block align-top'; __25a['alt'] = ''; const __25 = blop.h('img', __25a, __25c); __24c.push(__25);
      __26 = ' Blop'; Array.isArray(__26) ? __24c.push(...__26) : __24c.push(__26); ;
     const __24 = blop.h('a', __24a, __24c); __23c.push(__24);
    const __27c = []; const __27a = {}; __27a['class'] = 'navbar-toggler'; __27a['type'] = 'button'; __27a['data-toggle'] = 'collapse'; __27a['data-target'] = '#navbarSupportedContent'; __27a['aria-controls'] = 'navbarSupportedContent'; __27a['aria-expanded'] = 'false'; __27a['aria-label'] = 'Toggle navigation';
      const __28c = []; const __28a = {}; __28a['class'] = 'navbar-toggler-icon'; const __28 = blop.h('span', __28a, __28c); __27c.push(__28);
     const __27 = blop.h('button', __27a, __27c); __23c.push(__27);
    const __29c = []; const __29a = {}; __29a['class'] = 'collapse navbar-collapse'; __29a['id'] = 'navbarSupportedContent';
      const __30c = []; const __30a = {}; __30a['class'] = 'navbar-nav mr-auto';
        __31 = navItem('dog', links.dogPage, 'Breed game'); Array.isArray(__31) ? __30c.push(...__31) : __30c.push(__31); ;
        __32 = navItem('petstore', links.petStorePage, 'Pet store'); Array.isArray(__32) ? __30c.push(...__32) : __30c.push(__32); ;
        __33 = navItem('meme', links.memePage, 'Memes'); Array.isArray(__33) ? __30c.push(...__33) : __30c.push(__33); ;
        __34 = navItem('todo', links.todoPage, 'A basic todo app'); Array.isArray(__34) ? __30c.push(...__34) : __30c.push(__34); ;
        __35 = navItem('state', links.statePage, 'Components and state'); Array.isArray(__35) ? __30c.push(...__35) : __30c.push(__35); ;
        __36 = navItem('fetch', links.fetchPage, 'Fetch component'); Array.isArray(__36) ? __30c.push(...__36) : __30c.push(__36); ;
       const __30 = blop.h('ul', __30a, __30c); __29c.push(__30);
      const __37c = []; const __37a = {}; __37a['class'] = style['right-buttons'];
        if ((state.loading)) {
          const __38c = []; const __38a = {}; __38a['class'] = 'spinner-border text-primary'; __38a['role'] = 'status'; __38a['style'] = ({ marginRight: '1em' });
            const __39c = []; const __39a = {}; __39a['class'] = 'sr-only'; const __40 = 'Loading...'; Array.isArray(__40) ? __39c.push(...__40) : __39c.push(__40); const __39 = blop.h('span', __39a, __39c); __38c.push(__39);
           const __38 = blop.h('div', __38a, __38c); __37c.push(__38);
        }
        __41 = state.error ? (() => {const __42c = []; const __42a = {}; const __43 = `Error ${state.error}`; Array.isArray(__43) ? __42c.push(...__43) : __42c.push(__43); const __42 = blop.h('p', __42a, __42c); return __42;})() : undefined; Array.isArray(__41) ? __37c.push(...__41) : __37c.push(__41); ;
        const __44c = []; const __44a = {}; __44a['href'] = 'https://github.com/batiste/blop-language'; __44a['class'] = `btn btn-secondary ${style.btn}`;
          __45 = 'Fork on github'; Array.isArray(__45) ? __44c.push(...__45) : __44c.push(__45); ;
         const __44 = blop.h('a', __44a, __44c); __37c.push(__44);
        const __46c = []; const __46a = {}; __46a['href'] = 'https://github.com/batiste/blop-language/wiki'; __46a['class'] = `btn btn-secondary ${style.btn}`;
          __47 = 'Docs'; Array.isArray(__47) ? __46c.push(...__47) : __46c.push(__47); ;
         const __46 = blop.h('a', __46a, __46c); __37c.push(__46);
        const __48c = []; const __48a = {}; __48a['on'] = ({ click: saveStateEvent }); __48a['class'] = `btn btn-secondary ${style.btn}`;
          __49 = 'Save locale state on server'; Array.isArray(__49) ? __48c.push(...__49) : __48c.push(__49); ;
         const __48 = blop.h('button', __48a, __48c); __37c.push(__48);
       const __37 = blop.h('div', __37a, __37c); __29c.push(__37);
     const __29 = blop.h('div', __29a, __29c); __23c.push(__29);
   const __23 = blop.h('nav', __23a, __23c); return __23;
};

Index = (state) => {let __51, __62;
  function indexPage(e) {
    state.$.router.go('/');
    e.preventDefault();
  };
  const __50c = []; const __50a = {};
    __51 = navigation(state); Array.isArray(__51) ? __50c.push(...__51) : __50c.push(__51); ;
    const __52c = []; const __52a = {}; __52a['class'] = `${style.container} container`;
      const __53c = []; const __53a = {};
        const __54c = []; const __54a = {}; const __55 = state.page; Array.isArray(__55) ? __54c.push(...__55) : __54c.push(__55); const __54 = blop.h('b', __54a, __54c); __53c.push(__54);
       const __53 = blop.h('h1', __53a, __53c); __52c.push(__53);
      if (state.page === 'dog') {
        const __56c = []; const __56a = {}; __56a['state'] = state; const __56 = blop.c(DogPage, __56a, __56c, '__56'); __52c.push(__56);
      } else if (state.page === 'meme') {
        const __57c = []; const __57a = {}; __57a['state'] = state; const __57 = blop.c(MemePage, __57a, __57c, '__57'); __52c.push(__57);
      } else if (state.page === 'todo') {
        const __58c = []; const __58a = {}; __58a['todo'] = state; const __58 = blop.c(TodoListPage, __58a, __58c, '__58'); __52c.push(__58);
      } else if (state.page === 'petstore') {
        const __59c = []; const __59a = {}; __59a['state'] = state; const __59 = blop.c(PetStore, __59a, __59c, '__59'); __52c.push(__59);
      } else if (state.page === 'state') {
        const __60c = []; const __60a = {}; __60a['state'] = state; const __60 = blop.c(CounterPage, __60a, __60c, '__60'); __52c.push(__60);
      } else if (state.page === 'fetch') {
        const __61c = []; const __61a = {}; __61a['state'] = state; const __61 = blop.c(FetchPage, __61a, __61c, '__61'); __52c.push(__61);
      } else {
        __62 = linkList(state); Array.isArray(__62) ? __52c.push(...__62) : __52c.push(__62); ;
      }
     const __52 = blop.h('div', __52a, __52c); __50c.push(__52);
   const __50 = blop.h('div', __50a, __50c); return __50;
};
module.exports = { MemePage, DogPage, PetStore, TodoListPage, CounterPage, FetchPage, saveState, style, navigationLinks, linkList, navigation, Index };
